export default "__VITE_ASSET__DDhnqFcG__"